import { useEffect, useState } from 'react'

/**
 * Một nhịp đồng hồ chung cho cả màn hình. Mỗi ô bàn tự chạy timer riêng thì
 * 30 cái bàn là 30 lần vẽ lại không đồng bộ — một nhịp thì cả sơ đồ nhích cùng lúc.
 */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const tick = () => setNow(Date.now())
    const id = setInterval(tick, intervalMs)
    // Máy tính bảng để ngủ cả tiếng, mở ra là đồng hồ phải đúng ngay.
    const onVisible = () => {
      if (document.visibilityState === 'visible') tick()
    }
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      clearInterval(id)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [intervalMs])

  return now
}

/** Giá trị input[type=datetime-local] cho một mốc thời gian, theo giờ máy. */
export function toLocalInput(iso: string | null): string {
  const d = iso ? new Date(iso) : new Date()
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

/** Mốc giờ tròn gợi ý sẵn khi đặt bàn: lát nữa, trưa, tối, mai. */
export function quickReserveTimes(now = new Date()): { label: string; value: Date }[] {
  const at = (h: number, m = 0, addDays = 0) => {
    const d = new Date(now)
    d.setDate(d.getDate() + addDays)
    d.setHours(h, m, 0, 0)
    return d
  }

  const inHour = new Date(now.getTime() + 60 * 60_000)
  inHour.setSeconds(0, 0)

  const out: { label: string; value: Date }[] = [{ label: 'Sau 1 tiếng', value: inHour }]

  if (now.getHours() < 11) out.push({ label: 'Trưa 11:30', value: at(11, 30) })
  if (now.getHours() < 18) out.push({ label: 'Tối 18:00', value: at(18) })
  if (now.getHours() < 19) out.push({ label: 'Tối 19:30', value: at(19, 30) })
  out.push({ label: 'Mai 8:00', value: at(8, 0, 1) })

  return out.slice(0, 4)
}
